import { render, staticRenderFns } from "./oddsbase.vue?vue&type=template&id=47a98f60&"
import script from "./oddsbase.vue?vue&type=script&lang=js&"
export * from "./oddsbase.vue?vue&type=script&lang=js&"
import style0 from "./oddsbase.vue?vue&type=style&index=0&id=47a98f60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports